import { render, staticRenderFns } from "./PageBreak.vue?vue&type=template&id=78b8e923&"
import script from "./PageBreak.vue?vue&type=script&lang=js&"
export * from "./PageBreak.vue?vue&type=script&lang=js&"
import style0 from "./PageBreak.vue?vue&type=style&index=0&id=78b8e923&prod&lang=less&"
import style1 from "./PageBreak.vue?vue&type=style&index=1&id=78b8e923&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports